/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-11-01 15:49:24
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import { post, get } from 'src/api/http';
import * as types from './type';
import {ReturnPageData, TaskMess} from 'src/api/types.d';

class TaskMgnt {
    getMeterList (data: types.MeterListActionParams): Promise<ReturnPageData<types.MeterListActionList>> {
        return post('/amr/task/meter-list', data);
    }
    getOperatorList (data:types.OperateListParams): Promise<types.OperateListData[]> {
        return post('/amr/task/operator-list', data);
    }
    stopTask (data:types.TaskStopParams):Promise<TaskMess> {
        return post('/amr/task/stop', data);
    }
    changePriority (data: types.TaskPriorityParams): Promise<TaskMess> {
        return post('/amr/task/change-priority', data);
    }
    setExucuteTime (data:types.TaskSetExucuteTimeParams): Promise<TaskMess> {
        return post('/amr/task/set-execute-time', data);
    }
    listByTaskId (taskId: string): Promise<types.LogListRow[]> {
        return get('/amr/task/listByTaskId', {taskId});
    }
    getTaskStatistics (): Promise<types.QueryTaskStatistics[]> {
        return post('/amr/task/task-statistics');
    }
    resetBatchTask (data: types.ReasetTaskParams): Promise<boolean> {
        return post('/amr/task/reset-task', data);
    }
    resetTask (data: types.TaskResetParams): Promise<boolean> {
        return post('/amr/task/reset-task-bySn', data);
    }
    getTaskStatisticData (data: types.TaskStatisticsParams): Promise<types.TaskStatisticsInfo> {
        return get('/amr/task/task-statistics-date', data);
    }
}


export default new TaskMgnt();
